<template>
  <form-field-date-picker
    :label="label"
    v-model="filterValue"
    is-range
    size=""
    @change="handleInput"
  ></form-field-date-picker>
</template>

<script>
import dates from "../../services/dates";

export default {
  name: "FilterDateRange",
  props: {
    label: {
      type: String,
      default: "Date Range"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    filterVariable: {
      type: String,
      default: "dateRange"
    }
  },
  computed: {
    filterValue: {
      get() {
        return [
          this.validateAndFormatDate(this.$store.state[this.storeModule].filters[this.filterName][this.filterVariable][0]),
          this.validateAndFormatDate(this.$store.state[this.storeModule].filters[this.filterName][this.filterVariable][1])
        ]
      },
      set(value) {
        if (value) {
          value[0] = dates.convertJsDateToStartOf(value[0])
          value[1] = dates.convertJsDateToEndOf(value[1])
        }

        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          this.filterVariable,
          value
        ]);
      }
    },
    text() {
      if (this.filterValue[0] && this.filterValue[1]) {
        const startMonth = dates.formatAsMonthShort(dates.convertJSDateToISO(this.filterValue[0]));
        const startDay = dates.formatAsDay(dates.convertJSDateToISO(this.filterValue[0]))
        const endMonth = dates.formatAsMonthShort(dates.convertJSDateToISO(this.filterValue[1]));
        const endDay = dates.formatAsDay(dates.convertJSDateToISO(this.filterValue[1]))

        return `${this.label} ${startMonth} ${startDay} - ${endMonth} ${endDay}`;
      }

      return null;
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
    validateAndFormatDate(datetime) {
      if (!datetime) return null;

      return (datetime instanceof Date) ? datetime : dates.getJSDate(datetime)
    }
  }
}
</script>

<style scoped>

</style>
